module.exports = __webpack_public_path__ + "static/media/photo.6fa59c69.png";